import { Box } from '@mui/material';
import { getBusinessContacts } from 'lib/api/contacts';
import ContactsTable from 'lib/common/Tables/ContactsTable';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

const Signers = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const businessIdentifier = user?.businessIdentifier;
  const query = new URLSearchParams({
    isLegalRepresentative: 'true',
  }).toString();
  const { data, isPending } = getBusinessContacts(
    dispatch,
    businessIdentifier,
    query,
  );

  const contacts = data?.items ?? [];

  if (isPending) return <CenteredCircularProgress type="dialog" />;

  return (
    <>
      <Box mt={2}>
        <HeaderWithActions
          title="Aca podras ver una lista con los firmantes de tu empresa."
          variant="body1"
          type="subHeader"
        />
        <ContactsTable
          data={contacts}
          showBusiness={false}
          showActions={false}
        />
      </Box>
    </>
  );
};

export default Signers;
